//
//
//
//
//
//
//

export default {
  props: {
    label: {
      type: String,
      default: 'Terug',
    },
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
};
